import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { figures } from "@/mocks/figures";

const categories = [
  { label: "人物追踪", desc: "主角是谁、身份层叠与核验", icon: "ri-user-search-line", accent: "text-primary-700 bg-primary-100" },
  { label: "来源梳理", desc: "首发源头与传播路径还原", icon: "ri-route-line", accent: "text-accent-700 bg-accent-100" },
  { label: "当事人身份", desc: "爆料方与被拍者信息分层", icon: "ri-fingerprint-line", accent: "text-secondary-700 bg-secondary-100" },
  { label: "概念与辨析", desc: "主角、当事人与涉事主体之别", icon: "ri-question-answer-line", accent: "text-foreground-700 bg-foreground-100" },
];

export default function Home() {
  const featured = articles[0];
  const side = articles.slice(1, 4);
  const rest = articles.slice(4, 7);

  return (
    <div className="bg-background-50">
      {/* HERO */}
      <section className="relative overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=editorial%20newspaper%20investigation%20desk%20with%20magnifying%20glass%2C%20folded%20documents%20and%20photographs%20spread%20on%20warm%20cream%20wooden%20table%2C%20soft%20window%20light%2C%20warm%20vermilion%20and%20amber%20accent%20tones%2C%20cinematic%20depth%20of%20field%2C%20no%20people%2C%20atmospheric%20and%20moody%20editorial%20style&width=1600&height=900&seq=cf-hero-2026&orientation=landscape"
          alt="反差人物追踪编辑部桌面"
          className="absolute inset-0 h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/60 to-foreground-900/30" />
        <div className="relative mx-auto flex min-h-[560px] w-full max-w-7xl items-center px-4 py-16 md:px-6">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-sm font-medium text-accent-300">
              <span className="inline-block h-px w-8 bg-accent-400" />
              人物主角与当事人身份追踪
            </p>
            <h1 className="font-heading mt-5 text-4xl font-bold leading-tight text-background-50 md:text-5xl">
              反差人物主角是谁？<br />
              <span className="text-accent-300">我们持续追踪，但不替你看。</span>
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-background-200/90">
              围绕走红的「反差」内容，逐一梳理主角身份、当事人来源与传播链条。所有线索均标注来源与可信层级，理性看待每一份截图、录音与爆料。
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/renwu"
                className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-700"
              >
                查看主角档案
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/zixun"
                className="inline-flex items-center justify-center gap-2 rounded-md border border-background-200/60 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/20"
              >
                阅读来源梳理
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 py-8 md:grid-cols-4 md:px-6">
          {[
            { n: "46", label: "持续跟踪的档案", icon: "ri-file-search-line" },
            { n: "128", label: "已还原的传播链条", icon: "ri-share-forward-line" },
            { n: "37", label: "待交叉核验线索", icon: "ri-honour-line" },
            { n: "90%", label: "来源分级标注率", icon: "ri-shield-check-line" },
          ].map((s) => (
            <div key={s.label} className="flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-md bg-background-50 text-primary-600">
                <i className={`${s.icon} text-xl`} />
              </span>
              <div>
                <p className="font-heading text-2xl font-bold text-foreground-950">{s.n}</p>
                <p className="text-sm text-foreground-600">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-primary-600">栏目速览</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950">从哪一侧切进这个迷局</h2>
          </div>
          <Link to="/zixun" className="hidden items-center gap-1 text-sm text-foreground-600 hover:text-primary-700 sm:flex">
            全部内容 <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.label}
              to="/zixun"
              className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-md ${c.accent}`}>
                <i className={`${c.icon} text-xl`} />
              </span>
              <h3 className="font-heading mt-4 text-lg font-bold text-foreground-950">{c.label}</h3>
              <p className="mt-1.5 text-sm text-foreground-600">{c.desc}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* FEATURED + SIDE */}
      <section className="border-y border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
          <div className="flex items-end justify-between">
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">本期焦点</p>
              <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950">最新追踪与深度还原</h2>
            </div>
            <Link to="/zixun" className="text-sm text-foreground-600 hover:text-primary-700">
              查看全部 →
            </Link>
          </div>

          <div className="mt-6 grid gap-6 lg:grid-cols-3">
            {/* featured big */}
            <Link
              to={`/zixun/${featured.id}`}
              className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-6 lg:col-span-1"
            >
              <div>
                <span className="inline-block rounded-md bg-primary-600 px-3 py-1 text-xs text-background-50">
                  {featured.category}
                </span>
                <h3 className="font-heading mt-4 text-2xl font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                  {featured.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              </div>
              <div className="mt-6 flex items-center justify-between text-xs text-foreground-500">
                <span>{featured.date}</span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-eye-line" /> {featured.reads}
                </span>
              </div>
            </Link>

            {/* side list */}
            <div className="lg:col-span-2">
              <div className="flex h-full flex-col divide-y divide-background-200 rounded-lg border border-background-200 bg-background-50 px-6">
                {side.map((a) => (
                  <Link key={a.id} to={`/zixun/${a.id}`} className="group flex flex-1 items-center gap-4 py-5">
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-primary-600">{a.category}</span>
                        <span className="text-xs text-foreground-400">· {a.date}</span>
                      </div>
                      <h3 className="mt-1.5 font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                        {a.title}
                      </h3>
                      <p className="mt-1 hidden text-sm text-foreground-600 sm:block">{a.excerpt}</p>
                    </div>
                    <i className="shrink-0 text-foreground-300 transition-colors group-hover:text-primary-600 ri-arrow-right-line" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FIGURES GRID */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-secondary-700">主角档案精选</p>
            <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-950">正在持续追踪的几位「主角」</h2>
          </div>
          <Link to="/renwu" className="text-sm text-foreground-600 hover:text-primary-700">
            进入档案库 →
          </Link>
        </div>
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {figures.slice(0, 6).map((f) => (
            <Link
              key={f.id}
              to="/renwu"
              className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-700">
                  <i className="ri-fire-line" />
                  热度 {f.hot}
                </span>
                <span className="text-xs text-foreground-500">{f.code}</span>
              </div>
              <h3 className="font-heading mt-4 text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                {f.nick}
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                {f.category} · {f.area}
              </p>
              <p className="mt-3 line-clamp-2 text-sm text-foreground-600">{f.summary}</p>
              <p className="mt-3 text-xs font-medium text-secondary-700">{f.keypoint}</p>
            </Link>
          ))}
        </div>
      </section>

      {/* CAUTION NOTE */}
      <section className="bg-secondary-100">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6">
          <div className="flex flex-col items-start gap-4 rounded-lg bg-background-50 p-6 md:flex-row md:items-center">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
              <i className="ri-alert-line text-2xl" />
            </span>
            <div className="flex-1">
              <h2 className="font-heading text-lg font-bold text-foreground-950">理性看待，是我们最大的立场</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                本平台仅做公开信息的整理、分级与时间线还原，不替任何一方下结论。在当事人正式回应或权威渠道核实之前，请把一切截图与录音都视为「待确认」。
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-secondary-600 px-5 py-2.5 text-sm text-background-50 whitespace-nowrap transition-colors hover:bg-secondary-700"
            >
              阅读立场声明
            </Link>
          </div>
        </div>
      </section>

      {/* MORE LIST */}
      <section className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <h2 className="font-heading text-2xl font-bold text-foreground-950">更多来源梳理</h2>
        <div className="mt-6 grid gap-4 md:grid-cols-3">
          {rest.map((a) => (
            <Link
              key={a.id}
              to={`/zixun/${a.id}`}
              className="group rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300"
            >
              <span className="text-xs text-primary-600">{a.category}</span>
              <h3 className="font-heading mt-2 text-base font-bold leading-snug text-foreground-950 group-hover:text-primary-700">
                {a.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm text-foreground-600">{a.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}